module.exports = __webpack_public_path__ + "img/icon-arrow-bottom.fb5e7e93.svg";